/* global axios */
import ApiClient from './ApiClient';

class KaptionAssignableAssistants extends ApiClient {
  constructor() {
    // NOTICE: KAPTION-INTEGRATION
    super('assignable_assistants', { accountScoped: true });
  }

  get(inboxIds) {
    return axios.get(this.url, {
      params: { inbox_ids: inboxIds },
    });
  }
}

export default new KaptionAssignableAssistants();
